import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/analytics";
const ANA_URL = "https://gg-api.nationtonation.ca/api/analytics";
interface ReportData {
  id: string;
  created_at: string;
  customer_id: string;
  master_customer_id: string | null;
  customer_name: string;
  account_type: "Main" | "Subaccount";
  product_name: string;
  category: string;
  quantity: number;
  price: number;
  total: number;
  parentId?: string | null;
}



// Updated frontend API call (analyticsApi.ts)
export const trackSession = async (user_id: number) => {
  try {
    // Get approximate location from IP
    let location = null;
    try {
      const ipResponse = await fetch('https://ipapi.co/json/');
      const ipData = await ipResponse.json();
      location = {
        latitude: ipData.latitude,
        longitude: ipData.longitude,
        country: ipData.country_name,
        city: ipData.city,
        ip: ipData.ip
      };
    } catch (ipError) {
      console.log('IP geolocation failed:', ipError);
    }

    const response = await axios.post(`${BASE_URL}/track-session`, {
      visitor_ip: location?.ip || 'unknown',
      user_agent: navigator.userAgent,
      referrer: document.referrer || null,
      location, // Now properly includes location or null
      last_page: window.location.pathname,
      user_id
    });

    localStorage.setItem("session_id", response.data.session_id);
  } catch (error) {
    console.error("Error tracking session:", error);
  }
};

export const logEvent = async (event_type: string, metadata = {}) => {
  const session_id = localStorage.getItem("session_id");

  if (!session_id) return;

  try {
    await axios.post(`${BASE_URL}/log-event`, {
      session_id,
      event_type,
      metadata,
    });
  } catch (error) {
    console.error("Error logging event:", error);
  }
};

export const fetchRealtimeAnalytics = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/realtime`);
    return response.data;
  } catch (error) {
    console.error("Error fetching real-time analytics:", error);
    throw new Error("Failed to load real-time analytics");
  }
};

export const fetchDashboardAnalytics = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/dashboard`);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard analytics:", error);
    throw new Error("Failed to load dashboard data");
  }
};

export const fetchSalesTrends = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/sales-trends`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sales trends:", error);
    throw new Error("Failed to load sales trends");
  }
};

export const fetchTopProducts = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/top-products`);
    return response.data;
  } catch (error) {
    console.error("Error fetching top products:", error);
    throw new Error("Failed to load top products");
  }
};

export const fetchRecentActivities = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/recent-activities`);
    return response.data;
  } catch (error) {
    console.error("Error fetching recent activities:", error);
    throw new Error("Failed to load recent activities");
  }
};

export const getCustomerSpending = async (period?: string, customerId?: string) => {
  try {
    const response = await axios.get(`${BASE_URL}/customer-spending`, {
      params: { period, customerId }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer spending:", error);
    throw new Error("Failed to fetch customer spending");
  }
};





export const generateReport = async (params: {
  startDate?: string;
  endDate?: string;
  customerId?: string;
  productId?: string;
  category?: string;
}): Promise<ReportData[]> => { // updated to include account_type in the ReportData type
  try {
    const response = await axios.get(`${ANA_URL}/generate-report`, { params });
    return response.data;
  } catch (error) {
    console.error("Error generating report:", error);
    throw new Error("Failed to generate report");
  }
};


export const fetchAllCustomers = async (): Promise<Array<{id: string, name: string}>> => {
  const token = localStorage.getItem("token");
  const res = await axios.get("https://gg-api.nationtonation.ca/api/analytics/list-customers", {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return res.data.map((customer: any) => ({
    id: customer.id.toString(),
    name: customer.name || customer.dispensary_name || `Customer ${customer.id}`
  }));
};

export const fetchProductCategories = async (): Promise<Array<{id: string, name: string}>> => {
  const token = localStorage.getItem("token");
  try {
    const res = await axios.get("https://gg-api.nationtonation.ca/api/products/categories", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    // Handle both array of strings and array of objects
    if (Array.isArray(res.data)) {
      if (typeof res.data[0] === 'string') {
        return res.data.map((name: string, index: number) => ({
          id: index.toString(),
          name
        }));
      } else {
        return res.data.map((cat: any) => ({
          id: cat.id.toString(),
          name: cat.name
        }));
      }
    }
    
    // Handle object response if needed
    if (typeof res.data === 'object' && !Array.isArray(res.data)) {
      return Object.entries(res.data).map(([id, name]) => ({
        id,
        name: name as string
      }));
    }
    
    return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
// Add to api/analyticsApi.js
export const fetchLiveLocations = async () => {
  const response = await axios.get('https://gg-api.nationtonation.ca/api/analytics/live-locations');
  return response.data;
};